import { useWizardView } from "hooks/wizard-view";
import queryString from "query-string";
import * as React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { EventsService, OrderEventService } from "services";
import styled from "styled-components";

import { LoadingScreen } from "components";
import {
  AlertSubmitError,
  AvatarDefault,
  Button,
  ButtonBlue,
  WizardView,
  WizardViewContent,
} from "components/ma";
import { toast } from "components/ma/processing-toast";
import IconInfo from "components/ma/icons/mono/info";
import SweetAlert from "react-bootstrap-sweetalert";
import CurrencyFormat from "react-currency-format";
import MetaTags from "react-meta-tags";
import { Container as BSContainer, Table as BSTable } from "reactstrap";
import { BreadcrumbDashboard } from "../dashboard/components/breadcrumb";
import { FieldInputText, FieldSelectClub } from "./components";

import IconBadgeVerified from "components/ma/icons/color/badge-verified";
import IconAddress from "components/ma/icons/mono/address";
// import toastr from "toastr";

import classnames from "classnames";
import { useUserProfile } from "hooks/user-profile";
import { errorsUtil, stringUtil } from "utils";
import { FieldSelectNationality } from "../event-registration/components/field-select-nationality";
import AdsBanner from "./components/ads-banner";
import { FormEditName } from "./components/form-edit-name";
import { Show } from "./components/show-when";
import { useFormVerification } from "./hooks/form-verification";
import { useVerificationDetail } from "./hooks/verification-detail";
import { FieldSelectCountry } from "../event-registration/components/field-select-country";
import { FieldSelectProvince } from "./components/field-select-province";
import { FieldSelectCity } from "./components/field-select-city";
import { FieldSelectCityByCountry } from "./components/field-select-city-country";
import { FieldUploadImage } from "./components/field-upload-image";
import { useSubmitVerification } from "./hooks/submit-verification";

const tabList = [
  { step: 1, label: "Pendaftaran" },
  { step: 2, label: "Pemesanan" },
];

const initialFormState = {
  data: {
    category: null,
    club: null,
    participants: [
      { name: `member-email-${stringUtil.createRandom()}`, data: null },
      { name: `member-email-${stringUtil.createRandom()}`, data: null },
      { name: `member-email-${stringUtil.createRandom()}`, data: null },
    ],
  },
  errors: {},
};

function PageEventRegistration() {
  const { slug } = useParams();
  const { search } = useLocation();
  const { categoryId } = queryString.parse(search);
  const history = useHistory();

  const { currentStep, goToNextStep, goToPreviousStep, goToStep } =
    useWizardView(tabList);
  const [eventDetail, updateEventDetail] = React.useReducer(
    eventDetailReducer,
    {
      status: "idle",
      data: null,
      errors: null,
    }
  );
  const [eventCategories, updateEventCategories] = React.useReducer(
    eventCategoriesReducer,
    {
      status: "idle",
      data: null,
      errors: null,
    }
  );

  const { userProfile, refresh: refreshUserProfile } = useUserProfile();
  const { data: verificationDetail, fetchVerificationDetail } =
    useVerificationDetail(userProfile?.id);

  const [formData, updateFormData] = React.useReducer(
    formReducer,
    initialFormState
  );

  const [submitStatus, dispatchSubmitStatus] = React.useReducer(
    (state, action) => ({ ...state, ...action }),
    { status: "idle", errors: null }
  );

  const { category, club } = formData.data;

  const {
    updateField: updateVerification,
    data: dataVerification,
    errors: verificationErrors,
    handleValidation: handleValidationVerification,
    updateWithDependence,
    updateNIK,
    updateImage,
  } = useFormVerification(verificationDetail);

  const {
    submit: submitVerification,
    isLoading: isLoadingVerification,
    isError: isErrorVerification,
    errors: errorVerification,
  } = useSubmitVerification(dataVerification);

  const formErrors = formData.errors;
  const eventDetailData = eventDetail?.data;

  const isLoadingEventDetail = eventDetail.status === "loading";
  const eventId = eventDetailData?.id;
  const breadcrumpCurrentPageLabel = `Pendaftaran ${
    eventDetailData?.publicInformation.eventName || ""
  }`;

  const isLoadingSubmit = submitStatus.status === "loading";
  const isErrorSubmit = submitStatus.status === "error";

  const matchesTeamCategoryId = (id) => category?.teamCategoryId === id;
  const isCategoryIndividu = ["individu male", "individu female"].some(
    matchesTeamCategoryId
  );

  const _checkIsVerificationDone = (verifyStatus) => {
    const acceptedStatuses = [1, 3];
    return acceptedStatuses.indexOf(verifyStatus) > -1;
  };

  const isVerificationDone = _checkIsVerificationDone(
    userProfile?.verifyStatus
  );

  const getLandingPagePath = (url) => {
    if (!url) {
      return "#";
    }
    const segments = url.split("/");
    const segmentLength = segments.length;
    const path = `/${segments[segmentLength - 3]}/${
      segments[segmentLength - 2]
    }/${segments[segmentLength - 1]}`;
    return path;
  };

  const handleClickNext = () => {
    handleValidationVerification({
      onValid: () => {
        const isVerificationDoneNext = _checkIsVerificationDone(
          userProfile?.verifyStatus
        );

        // const validationOrderOptions = {
        //   onValid: () => {
        //     goToNextStep();
        //   },
        //   oninvalid: (invalidErrors) => {
        //     _displayToasts(invalidErrors);
        //   },
        // };

        if (!isVerificationDoneNext) {
          submitVerification({
            onSuccess: () => {
              toast.success("Data verifikasi berhasil disimpan");
              refreshUserProfile();
              goToNextStep();
            },
          });
        } else {
          refreshUserProfile();
          goToNextStep();
          // handleValidationOrder(validationOrderOptions);
        }
      },
    });
  };

  const handleSubmitOrder = async () => {
    dispatchSubmitStatus({ status: "loading", errors: null });

    const payload = {
      club_id: club?.detail.id || 0,
      event_id: eventDetail?.data?.id,
    };

    const result = await OrderEventService.registerOfficial(payload);
    if (result.success) {
      dispatchSubmitStatus({ status: "success" });
      history.push(
        `/dashboard/transactions-official/${result?.data?.archeryEventOfficial?.id}`
      );
    } else {
      const errorData = errorsUtil.interpretServerErrors(result);
      dispatchSubmitStatus({ status: "error", errors: errorData });
    }
  };

  // function _displayToasts(errors) {
  //   const messages = _makeErrorMessageList(errors);
  //   for (const message of messages) {
  //     toastr.error(message);
  //   }
  // }

  // function _makeErrorMessageList(errors) {
  //   if (errors && typeof errors === "string") {
  //     return [errors];
  //   }

  //   if (errors) {
  //     const messages = [];
  //     for (const field in errors) {
  //       for (const message of errors[field]) {
  //         messages.push(message);
  //       }
  //     }

  //     if (messages.length) {
  //       return messages;
  //     }
  //   }

  //   return ["Error tidak diketahui."];
  // }

  React.useEffect(() => {
    const getEventDetail = async () => {
      updateEventDetail({ status: "loading", errors: null });
      const result = await EventsService.getDetailEvent({ slug });
      if (result.success) {
        updateEventDetail({ status: "success", data: result.data });
      } else {
        updateEventDetail({ status: "error", errors: result.errors });
      }
    };

    getEventDetail();
  }, []);

  React.useEffect(() => {
    if (!eventId) {
      return;
    }
    const getCategories = async () => {
      updateEventCategories({ status: "loading", errors: null });
      const result = await EventsService.getCategory({ event_id: eventId });
      if (result.success) {
        updateEventCategories({ status: "success", data: result.data });
      } else {
        updateEventCategories({ status: "error", errors: result.errors });
      }
    };
    getCategories();
  }, [eventId]);

  React.useEffect(() => {
    if (!eventCategories.data) {
      return;
    }

    let category;
    for (const group in eventCategories.data) {
      const targetCategory = eventCategories.data[group].find(
        (category) => parseInt(category.id) === parseInt(categoryId)
      );
      if (targetCategory) {
        category = targetCategory;
        break;
      }
    }

    category && updateFormData({ category });
  }, [eventCategories]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  return (
    <StyledPageWrapper>
      <MetaTags>
        <title>
          Pendaftaran {eventDetailData?.publicInformation.eventName || ""} |
          MyArchery.id
        </title>
        <meta
          id="meta-description"
          name="description"
          content="Bergabunglah bersama MyArchery.id"
        />
        <meta id="og-title" property="og:title" content="MyArchery.id" />
      </MetaTags>

      <Container fluid>
        <BreadcrumbDashboard
          to={getLandingPagePath(eventDetailData?.publicInformation.eventUrl)}
        >
          {breadcrumpCurrentPageLabel}
        </BreadcrumbDashboard>

        <StepIndicator>
          <Step
            className={classnames({
              "step-active": currentStep === 1,
              "step-done": currentStep > 1,
            })}
            onClick={() => currentStep > 1 && goToStep(1)}
          >
            1. Pendaftaran
          </Step>
          <StepArrow>&#10097;</StepArrow>
          <Step className={classnames({ "step-active": currentStep === 2 })}>
            2. Pemesanan
          </Step>
        </StepIndicator>

        <SplitDisplay>
          <div>
            <WizardView currentStep={currentStep}>
              <WizardViewContent noContainer>
                <ContentCard>
                  <MainCardHeader>
                    <WrappedIcon>
                      <IconAddress />
                    </WrappedIcon>
                    <MainCardHeaderText>Detail Pendaftaran</MainCardHeaderText>
                  </MainCardHeader>

                  <SplitFieldItem>
                    <FieldInputText
                      placeholder="Kategori"
                      value="Official"
                      onChange={() => {}}
                    >
                      Kategori
                    </FieldInputText>
                  </SplitFieldItem>

                  {userProfile ? (
                    <React.Fragment>
                      <FieldInputText
                        placeholder="Nama Pendaftar"
                        disabled
                        value={userProfile.name}
                        onChange={() => {}}
                      >
                        Nama Pendaftar
                      </FieldInputText>
                      <SubtleFieldNote>
                        Nama pendaftar merupakan nama yang akan menjadi
                        official. Untuk merubah nama, silahkan klik{" "}
                        <FormEditName
                          userProfile={userProfile}
                          onProfileUpdated={fetchVerificationDetail}
                        >
                          di sini
                        </FormEditName>
                      </SubtleFieldNote>
                      <SplitFields>
                        <SplitFieldItem>
                          <FieldInputText
                            placeholder="Email"
                            disabled
                            value={userProfile.email}
                            onChange={() => {}}
                          >
                            Email
                          </FieldInputText>
                        </SplitFieldItem>

                        <SplitFieldItem>
                          <FieldInputText
                            placeholder="No. Telepon"
                            disabled
                            value={userProfile.phoneNumber}
                            onChange={() => {}}
                          >
                            No. Telepon
                          </FieldInputText>
                        </SplitFieldItem>
                      </SplitFields>
                    </React.Fragment>
                  ) : (
                    <div>Sedang memuat data pengguna...</div>
                  )}

                  <NoticeBar>
                    Kartu ID Official tidak bisa dipindahtangankan
                  </NoticeBar>

                  <FieldSelectNationality
                    value={dataVerification.isWna || 0}
                    onChange={(value) =>
                      updateVerification("isWna", parseInt(value))
                    }
                    disabled={isVerificationDone}
                  />

                  <Show when={!dataVerification.isWna}>
                    <FieldSelectProvince
                      value={dataVerification.province}
                      onChange={(opt) =>
                        updateWithDependence("province", opt, "city")
                      }
                      disabled={isVerificationDone}
                      errors={verificationErrors.province}
                      required
                    />

                    <FieldSelectCity
                      provinceId={dataVerification.province?.value}
                      value={dataVerification.city}
                      onChange={(opt) => updateVerification("city", opt)}
                      disabled={
                        isVerificationDone || !dataVerification.province?.value
                      }
                      errors={verificationErrors.city}
                      required
                    />

                    <FieldInputText
                      label="NIK"
                      placeholder="Masukkan 16 digit nomor KTP/KK"
                      value={dataVerification.nik}
                      onChange={updateNIK}
                      disabled={isVerificationDone}
                      errors={verificationErrors.nik}
                      required
                    />

                    <FieldUploadImage
                      label="Foto KTP/KK"
                      placeholder="Unggah gambar dengan file JPG/PNG"
                      name="imageKTP"
                      value={dataVerification.imageKTP}
                      onChange={(value) => updateImage("imageKTP", value)}
                      disabled={isVerificationDone}
                      errors={verificationErrors.imageKTP}
                      required
                    />

                    <SubtleFieldNote>
                      Anda cukup melakukan verifikasi umur sekali di sini. Jika
                      ada perubahan nama, Anda perlu mengisi ulang data.
                    </SubtleFieldNote>

                    <FieldInputText
                      label="Alamat Lengkap"
                      placeholder="Masukkan alamat sesuai KTP/KK"
                      value={dataVerification.address}
                      onChange={(value) => updateVerification("address", value)}
                      disabled={isVerificationDone}
                      errors={verificationErrors.address}
                      required
                    />
                  </Show>

                  <Show when={dataVerification.isWna}>
                    <FieldSelectCountry
                      label="Negara"
                      placeholder="Pilih negara sesuai paspor"
                      value={dataVerification.wnaCountry}
                      onChange={(opt) =>
                        updateWithDependence("wnaCountry", opt, "wnaCity")
                      }
                      disabled={isVerificationDone}
                      errors={verificationErrors.wnaCountry}
                      required
                    />
                    <FieldSelectCityByCountry
                      label="Kota (Sesuai dengan paspor)"
                      placeholder="Pilih kota"
                      countryId={dataVerification.wnaCountry?.value}
                      value={dataVerification.wnaCity}
                      onChange={(opt) => updateVerification("wnaCity", opt)}
                      disabled={
                        isVerificationDone ||
                        !dataVerification.wnaCountry?.value
                      }
                      errors={verificationErrors.wnaCity}
                      required
                    />
                    <FieldInputText
                      label="Nomor Paspor"
                      placeholder="Masukkan nomor paspor"
                      value={dataVerification.wnaPassportNumber}
                      onChange={(value) =>
                        updateVerification("wnaPassportNumber", value)
                      }
                      disabled={isVerificationDone}
                      errors={verificationErrors.wnaPassportNumber}
                      required
                    />
                    <FieldUploadImage
                      label="Foto Paspor"
                      placeholder="Unggah gambar dengan file JPG/PNG"
                      name="imagePassport"
                      value={dataVerification.imagePassport}
                      onChange={(value) => updateImage("imagePassport", value)}
                      disabled={isVerificationDone}
                      errors={verificationErrors.imagePassport}
                      required
                    />
                    <SubtleFieldNote>
                      Anda cukup melakukan verifikasi umur sekali di sini. Jika
                      ada perubahan nama, Anda perlu mengisi ulang data.
                    </SubtleFieldNote>
                    <FieldInputText
                      label="Alamat Lengkap"
                      placeholder="Masukkan alamat sesuai paspor"
                      value={dataVerification.wnaAddress}
                      onChange={(value) =>
                        updateVerification("wnaAddress", value)
                      }
                      disabled={isVerificationDone}
                      errors={verificationErrors.wnaAddress}
                      required
                    />
                  </Show>

                  <h4 className="mt-3">Data Official</h4>

                  <FieldSelectClub
                    required={category?.id && !isCategoryIndividu}
                    value={club}
                    onChange={(clubValue) =>
                      updateFormData({ club: clubValue })
                    }
                    errors={formErrors.club}
                  >
                    Nama Klub
                  </FieldSelectClub>
                  {isCategoryIndividu && (
                    <SubtleFieldNote>
                      Dapat dikosongkan jika tidak mewakili klub
                    </SubtleFieldNote>
                  )}
                </ContentCard>
              </WizardViewContent>

              <WizardViewContent noContainer>
                <ContentCard>
                  <MainCardHeader>
                    <WrappedIcon>
                      <IconAddress />
                    </WrappedIcon>
                    <MainCardHeaderText>Detail Pendaftar</MainCardHeaderText>
                  </MainCardHeader>

                  {userProfile ? (
                    <BSTable responsive className="mt-3">
                      <tbody>
                        <tr>
                          <td>Nama Pendaftar</td>
                          <td width="16">:</td>
                          <td>
                            <div>{userProfile.name}</div>
                          </td>
                        </tr>
                        <tr>
                          <td>Email</td>
                          <td width="16">:</td>
                          <td>
                            <div>{userProfile.email}</div>
                          </td>
                        </tr>
                        <tr>
                          <td>No. Telepon</td>
                          <td width="16">:</td>
                          <td>
                            {userProfile.phoneNumber || <span>&ndash;</span>}
                          </td>
                        </tr>
                      </tbody>
                    </BSTable>
                  ) : (
                    <div>Sedang memuat data pengguna...</div>
                  )}
                </ContentCard>

                <ParticipantCard>
                  <ParticipantHeadingLabel>
                    Data Official
                  </ParticipantHeadingLabel>

                  <ParticipantMediaObject>
                    <MediaParticipantAvatar>
                      <ParticipantAvatar>
                        {userProfile?.avatar ? (
                          <img
                            className="club-logo-img"
                            src={userProfile?.avatar}
                          />
                        ) : (
                          <AvatarDefault fullname={userProfile?.name} />
                        )}
                      </ParticipantAvatar>
                    </MediaParticipantAvatar>

                    <MediaParticipantContent>
                      <ParticipantName>
                        <span>{userProfile?.name}</span>
                        <span>
                          <IconBadgeVerified />
                        </span>
                      </ParticipantName>

                      <LabelWithIcon>{club?.detail.name}</LabelWithIcon>
                    </MediaParticipantContent>
                  </ParticipantMediaObject>
                </ParticipantCard>
                {/* {isCategoryIndividu && (
                  <ParticipantCard>
                    <ParticipantHeadingLabel>
                      Data Official
                    </ParticipantHeadingLabel>

                    <ParticipantMediaObject>
                      <MediaParticipantAvatar>
                        <ParticipantAvatar>
                          {userProfile?.avatar ? (
                            <img
                              className="club-logo-img"
                              src={userProfile?.avatar}
                            />
                          ) : (
                            <AvatarDefault fullname={userProfile?.name} />
                          )}
                        </ParticipantAvatar>
                      </MediaParticipantAvatar>

                      <MediaParticipantContent>
                        <ParticipantName>
                          <span>{userProfile?.name}</span>
                          <span>
                            <IconBadgeVerified />
                          </span>
                        </ParticipantName>

                        <LabelWithIcon>{club?.detail.name}</LabelWithIcon>
                      </MediaParticipantContent>
                    </ParticipantMediaObject>
                  </ParticipantCard>
                )} */}
              </WizardViewContent>
            </WizardView>
          </div>

          <div>
            {isLoadingEventDetail ? (
              <TicketCard>Sedang memuat data event...</TicketCard>
            ) : eventDetailData ? (
              <TicketCard>
                <h4 className="mb-3">Tiket Lomba</h4>

                <EventMediaObject>
                  <div>
                    <span
                      style={{
                        display: "inline-block",
                        overflow: "hidden",
                        width: 60,
                        height: 60,
                        borderRadius: 4,
                      }}
                    >
                      <img
                        src={eventDetailData?.publicInformation.eventBanner}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </span>
                  </div>

                  <EventMediaObjectContent>
                    <h5>{eventDetailData?.publicInformation.eventName}</h5>
                    <p className="mb-0">
                      {eventDetailData?.publicInformation.eventLocation}
                    </p>
                  </EventMediaObjectContent>
                </EventMediaObject>

                <TicketDivider />

                <TicketSectionDetail>
                  <div>
                    <DetailLabel>Jenis Regu</DetailLabel>
                    <DetailValue>Official</DetailValue>
                  </div>
                </TicketSectionDetail>

                <div className="d-flex flex-column justify-content-between">
                  <TicketSectionTotal>
                    <div>
                      <LabelTotal>Total Pembayaran</LabelTotal>
                    </div>
                    <div>
                      {eventDetail?.data?.officialFee ? (
                        <>
                          <TotalWithCurrency
                            displayType={"text"}
                            value={Number(eventDetail?.data?.officialFee)}
                            prefix="Rp"
                            thousandSeparator={"."}
                            decimalSeparator={","}
                            decimalScale={0}
                            fixedDecimalScale
                          />
                        </>
                      ) : (
                        <>
                          <TotalWithCurrency
                            displayType={"text"}
                            value={Number(eventDetail?.data?.officialFee)}
                            prefix="Rp"
                            thousandSeparator={"."}
                            decimalSeparator={","}
                            decimalScale={0}
                            fixedDecimalScale
                          />
                        </>
                      )}
                    </div>
                  </TicketSectionTotal>

                  {currentStep === 1 ? (
                    <>
                      <ButtonBlue onClick={() => handleClickNext()}>
                        Selanjutnya
                      </ButtonBlue>
                      <AlertSubmitError
                        isError={isErrorVerification}
                        errors={errorVerification}
                        onConfirm={() =>
                          dispatchSubmitStatus({ status: "idle" })
                        }
                      />
                    </>
                  ) : (
                    <React.Fragment>
                      <ButtonConfirmPayment
                        onConfirm={() => handleSubmitOrder()}
                        onCancel={() => goToPreviousStep()}
                      />
                      <AlertSubmitError
                        isError={isErrorSubmit}
                        errors={submitStatus.errors}
                        onConfirm={() =>
                          dispatchSubmitStatus({ status: "idle" })
                        }
                      />
                    </React.Fragment>
                  )}
                </div>
              </TicketCard>
            ) : (
              <TicketCard>Ada kesalahan dalam memuat data.</TicketCard>
            )}
          </div>
        </SplitDisplay>
        <AdsBanner />
      </Container>
      <LoadingScreen loading={isLoadingSubmit || isLoadingVerification} />
    </StyledPageWrapper>
  );
}

const StyledPageWrapper = styled.div`
  font-family: "Inter", sans-serif;
`;

const Container = styled(BSContainer)`
  margin-bottom: 5rem;
`;

const StepIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  padding: 6px 0.75rem;
  border-radius: 0.5rem;
  background-color: #ffffff;
`;

const Step = styled.span`
  flex-basis: 100%;
  display: inline-block;
  padding: 0.5rem 0.75rem;
  border-radius: 0.25rem;
  font-weight: 600;

  &.step-active {
    background-color: var(--ma-blue-primary-50);
    color: var(--ma-blue);
    font-weight: 600;
  }

  &.step-done {
    cursor: pointer;
    background-color: var(--ma-blue-primary-50);
    font-weight: 400;
  }
`;

const StepArrow = styled.span`
  width: 120px;
  padding: 0.5rem 0.75rem;
  text-align: center;
`;

const SplitDisplay = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 2rem 1rem;
`;

const ContentCard = styled.div`
  margin-bottom: 1rem;
  padding: 1.5rem;
  padding-bottom: 2.5rem;
  border-radius: 0.5rem;
  background-color: #ffffff;
`;

const MainCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

const SubtleFieldNote = styled.div`
  color: var(--ma-gray-400);
`;

const MainCardHeaderText = styled.h4`
  margin: 0;
`;

const WrappedIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: solid 1px #c4c4c4;
`;

const SplitFields = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.375rem;
`;

const SplitFieldItem = styled.div`
  flex: 1 1 13.75rem;
`;

const ParticipantCard = styled.div`
  margin-bottom: 1rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  background-color: #ffffff;
`;

const ParticipantHeadingLabel = styled.div`
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  background-color: var(--ma-blue-primary-50);
  font-size: 15px;
  font-weight: 600;
`;

const ParticipantMediaObject = styled.div`
  margin: 1.25rem 0;
  display: flex;
  gap: 1.5rem;
`;

const MediaParticipantAvatar = styled.div`
  flex-grow: 0;
`;

const ParticipantAvatar = styled.div`
  overflow: hidden;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
`;

const MediaParticipantContent = styled.div`
  margin: auto 0;
`;

const ParticipantName = styled.h5`
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
`;

function LabelWithIcon({ icon, children }) {
  return (
    <StyledLabelWithIcon>
      {icon && <span className="label-icon">{icon}</span>}
      <span>{children}</span>
    </StyledLabelWithIcon>
  );
}

const StyledLabelWithIcon = styled.p`
  margin: 0;
  margin-bottom: 0.5rem;
  color: var(--ma-gray-500);

  .label-icon {
    margin-right: 0.5rem;
  }
`;

const EventMediaObject = styled.div`
  display: flex;
  gap: 1rem;
`;

const EventMediaObjectContent = styled.div`
  flex: 1 1 0%;
  margin: auto;
`;

const TicketCard = styled(ContentCard)`
  box-shadow: 0px 7.84391px 15.6878px rgba(18, 38, 63, 0.0313726);
`;

const TicketDivider = styled.hr`
  margin: 2rem 0;
`;

const TicketSectionDetail = styled.div`
  margin-bottom: 4rem;
`;

const DetailLabel = styled.h6`
  font-weight: 400;
`;

const isTextMuted = ({ muted }) => (muted ? "color: var(--ma-gray-400);" : "");

const DetailValue = styled.p`
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
  ${isTextMuted}
`;

const TicketSectionTotal = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const LabelTotal = styled.span`
  font-weight: 600;
  font-size: 15px;
`;

const TotalWithCurrency = styled(CurrencyFormat)`
  color: var(--ma-blue);
  font-size: 18px;
  font-weight: 600;
`;

const StyledNoticeBar = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: var(--ma-blue-primary-50);
  color: var(--ma-blue);
`;

function NoticeBar({ children }) {
  return (
    <StyledNoticeBar>
      <span>
        <IconInfo />
      </span>
      <span>{children}</span>
    </StyledNoticeBar>
  );
}

function ButtonConfirmPayment({ onConfirm, onCancel }) {
  const [isAlertOpen, setAlertOpen] = React.useState(false);

  const handleConfirmSubmit = () => {
    setAlertOpen(false);
    onConfirm?.();
  };

  const handleCancelSubmit = () => {
    setAlertOpen(false);
    onCancel?.();
  };

  return (
    <React.Fragment>
      <ButtonBlue onClick={() => setAlertOpen(true)}>
        Lanjutkan Pembayaran
      </ButtonBlue>
      <SweetAlert
        show={isAlertOpen}
        title=""
        custom
        btnSize="md"
        onConfirm={handleConfirmSubmit}
        style={{ padding: "1.25rem" }}
        customButtons={
          <span className="d-flex flex-column w-100" style={{ gap: "0.5rem" }}>
            <Button
              onClick={handleCancelSubmit}
              style={{ color: "var(--ma-blue)" }}
            >
              Cek Kembali
            </Button>
            <ButtonBlue onClick={handleConfirmSubmit}>Sudah Benar</ButtonBlue>
          </span>
        }
      >
        <p>Apakah data pemesanan Anda sudah benar?</p>
      </SweetAlert>
    </React.Fragment>
  );
}

function eventDetailReducer(state, action) {
  if (action) {
    return { ...state, ...action };
  }
  return state;
}

function eventCategoriesReducer(state, action) {
  if (action) {
    return { ...state, ...action };
  }
  return state;
}

function formReducer(state, action) {
  if (action.type === "CHANGE_CATEGORY") {
    // Kasih default user profile hanya kalau kategorinya individual
    // selain itu reset ke kosongan semua
    const nextParticipantsState = state.data.participants.map((member) => ({
      ...member,
      data: null,
    }));

    return {
      ...state,
      data: {
        ...state.data,
        category: action.payload,
        // reset field-field data peserta
        teamName: "",
        // club: null,
        participants: nextParticipantsState,
      },
    };
  }

  if (action.type === "FIELD_MEMBER_EMAIL") {
    const nextParticipantsState = state.data.participants.map((member) => {
      if (member.name === action.name) {
        return { ...member, data: action.payload };
      }
      return member;
    });

    return {
      ...state,
      data: { ...state.data, participants: nextParticipantsState },
    };
  }

  if (action.type === "FORM_INVALID") {
    return {
      ...state,
      errors: action.errors,
    };
  }

  if (action) {
    return {
      ...state,
      data: { ...state.data, ...action },
    };
  }

  return state;
}

export default PageEventRegistration;
